<template>
  <div @drop="onDropWatchfaceFile" @dragover.prevent>
    <HomeWatchfaceList />
  </div>
</template>

<script setup lang="ts">
import { useEditorDrag, useWebVersion } from '@/hooks';
import { onActivated } from 'vue';
defineOptions({
  name: 'HomePage'
});
const { onDropWatchfaceFile } = useEditorDrag();
const { autoCheckVersion } = useWebVersion();

onActivated(() => {
  autoCheckVersion();
});
</script>

<style scoped></style>
